import React from "react";
import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import Why_Section from "../Why_Us/Why_Section/Why_Section";
import StatsSection from "../StatsSection/StatsSection";
import Testimonials from "../Why_Us/Testimonials/Testimonials";
import ReadyToStart from "../Home/Ready_To_Start/Ready_To_Start";
import GlobalCareerCTA from "../Home/GlobalCareerCTA/GlobalCareerCTA";
import CommitmentSection from "./Commitment_Section/Commitment_Section";

function Why_Us() {
  return (
    <>
      <Common_Banner
        image="/assets/images/services_page/banner.png"
        title="Why Choose Us"
        subtitle="Industry-leading recruitment with unmatched expertise and proven success record"
      />

      <Why_Section />

      <StatsSection />

      <CommitmentSection />

      <Testimonials />

      {/* <ReadyToStart
        title="Join Thousands of Successfull Professionals"
        description="Start your overseas career journey with the most trusted recruitment agency in India."
        buttonText="Apply Now"
      /> */}
      <GlobalCareerCTA />
    </>
  );
}

export default Why_Us;
